import styled from 'styled-components';
import { IconButton, ListItem } from '@material-ui/core';
import { PRIMARY } from '../../../shared/styles/colors';

export const Wrapper = styled.section`
  padding: 0 18px 39px;
  width: 240px;
  box-sizing: border-box;

  @media (min-width: 600px) {
    padding: 0 39px 39px;
    min-width: 318px;
  }
`;

export const ReturnButton = styled(IconButton)`
  transform: translateX(-24px);
`;

export const NavItem = styled(ListItem)`
  font-size: 16px;
  font-style: normal;
  color: ${PRIMARY};
  height: 55px;
  display: flex;
  align-items: center;

  & > .active {
    font-weight: 600;
  }

  & > a {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
  }
`;
